import { AppThunk } from "../../thunks";
import { postAuthOTPAPI, postUserLoginAPI} from "../../services/restcall";
import { toggleLoadingIndicator } from "../system/actions";
import { MessageResponse } from "../system/types";
import { setMessageResponse } from "../system/actions";
import { AuthOTPState } from "./types";
import { login } from '../../components/User/Auth';
import configureApiRestService  from '../../services/apiservice';

export const postAuthOTP = (authOTP: AuthOTPState): AppThunk => async (dispatch, getSate) => {
    dispatch(toggleLoadingIndicator(true));
    debugger;
    const responseData = await postAuthOTPAPI(authOTP);
    if(responseData.Error !== null){
        const errorResponse=responseData.Error;
        if (errorResponse.status >= 400 && errorResponse !== null) {
            const message : MessageResponse = {
                code: errorResponse.status,
                message: [errorResponse.errors.error[0]]
            };
            dispatch(setMessageResponse(message));
        }
    }
    else
    {
        dispatch(setMessageResponse(null));
    }
    dispatch(toggleLoadingIndicator(false));
    return responseData;
};

export const postUserLogin = (authOTP: AuthOTPState): AppThunk => async (dispatch, getSate) => {
    dispatch(toggleLoadingIndicator(true));
    const responseData = await postUserLoginAPI(authOTP);
    if(responseData.Error !== null)
    {
        const errorResponse=responseData.Error.error;
        if (errorResponse.status >= 400 && errorResponse !== null) {
            const message : MessageResponse = {
                code: errorResponse.status,
                message: ["Credenciales incorrectas revise su identificación o código de seguridad ingresados"]
            };
            dispatch(setMessageResponse(message));
        }
    }
    else
    {
        if (responseData.StatusCode === 200)
        {
            login(responseData.Response.token);
            configureApiRestService();
        }
        dispatch(setMessageResponse(null));
    }
    dispatch(toggleLoadingIndicator(false));
    return responseData;
};